import { useCorrectiveImages } from '@/modules/adjusterReportModules/IncidentParticipants/store/correctiveImages/useCorrectiveImages';
import BodyPostButton from '@/modules/adjusterReportModules/Insurer-information/components/images/correctiveImages/components/bodyInquiredForm/components/bodyPostButton/BodyPostButton';
import BodyInquiredFormTabs from '@/modules/adjusterReportModules/Insurer-information/components/images/correctiveImages/components/bodyInquiredForm/components/tabs/BodyInquiredFormTabs';
import BodyInquiredFormList from '@/modules/adjusterReportModules/Insurer-information/components/images/correctiveImages/components/bodyInquiredFormList/BodyInquiredFormList';
import { getBodyPreviousCorrectiveImagesOptions } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyPreviousCorrectiveImages/getBodyPreviousCorrectiveImagesOptions';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Box } from 'styled-system/jsx';

const BodyInquiredCorrectiveForm = () => {
  const { id } = useParams();
  const { data } = useQuery(
    getBodyPreviousCorrectiveImagesOptions({ id: +id! }),
  );
  const { setPreFetchedCorrectiveImages } = useCorrectiveImages();

  useEffect(() => {
    if (data) {
      setPreFetchedCorrectiveImages(data);
    }
  }, [data]);

  return (
    <Box display={'flex'} flexDirection={'column'} gap={24}>
      <BodyInquiredFormTabs />
      <BodyInquiredFormList />
      <BodyPostButton />
    </Box>
  );
};

export default BodyInquiredCorrectiveForm;
